export const limitKeys = {
  minWidth: 'minWidth',
  minHeight: 'minHeight',
  maxSize: 'maxSixze',
};

export const extensionToMimeTypeMap = {
  apng: 'image/apng',
  avif: 'image/avif',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  svg: 'image/svg+xml',
  webp: 'image/webp',
  bmp: 'image/bmp',
};
